import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import { useEffect } from "react";

const GET_COMPANY_BENEFITS_INVOICES = gql`
  query CompanyBenefitInvoices($sliceNumber: Int!) {
    companyBenefitInvoices(companyBenefitInvoicesRequest: { sliceNumber: $sliceNumber }) {
       companyBenefits {
        uuid
        companyBenefitInvoiceFileUuid
        year
        month
        invoiceDate
        amountExcludingVat
        totalAmount
        benefitType
        comment
        currency
        vatList {
          vatRate
          vatAmount
          vatUuid
        }
      }
      hasNext
    }
  }
`;

export const useCompanyBenefitInvoices = (sliceNumber) => {

  const { loading, error, data , refetch} = useQuery(GET_COMPANY_BENEFITS_INVOICES, {
    variables: { sliceNumber },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    refetch(sliceNumber)
  }, [sliceNumber]);

  return { loading, error, data: data?.companyBenefitInvoices, refetch };
};
